export default function validateCreateExamen(values) {
    let errors = {};
  
    // tituloCiclo Errors
    if (!values.tituloExamen) {
      errors.tituloExamen = "Titulo de Examen requirido";
    } else if (values.tituloExamen.length < 4) {
      errors.tituloExamen = "Titulo de Examen debe ser por lo menos 4 caracteres";
    }
    if (!values.fechaExamen) {
        errors.fechaExamen = "Fecha de Examen requirido";
      } else if (values.fechaExamen.length < 4) {
        errors.fechaExamen = "Fecha de Examen debe ser por lo menos 4 caracteres";
      }
      if (!values.urlExamen) {
        errors.urlExamen = "url de Examen requirido";
      } else if (values.urlExamen.length < 4) {
        errors.urlExamen = "url de Examen debe ser por lo menos 4 caracteres";
      }

  
    return errors;
  }
